import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)



//创建路由规则数组
const routes = [
  {
    path: '/',
    name: 'pages',
    component: () => import( '../views/pages/index.vue')
  },
  {
    path: "/onlineZip",
    name: 'onlineZip',
    component: () => import( '../views/pages/onlineZip.vue')
  },
  {
    path: "/gltfPlaneAnalysis",
    name: 'gltfPlaneAnalysis',
    component: () => import( '../views/pages/gltfPlaneAnalysis.vue')
  }
]

//实例化路由
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//导出路由
export default router
